import React, { Component } from 'react';

class TermConditions extends Component {
  render() {
    return (
      <div className="modal fade" id='TermAndConditionsModal' tabIndex="-1" role="dialog" aria-labelledby='TermAndConditionsModal' aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <i className="lnr lnr-cross"></i>
              </button>
              <h4 className="modal-terms-title">Termos e Condições</h4>
              <p className="modal-terms-text">Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio maiores placeat enim aliquid! Vel earum suscipit, eveniet iure deleniti molestias, ad nesciunt deserunt reprehenderit enim maiores quia minima, sint neque!</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TermConditions;
